import {
  CATALOG_SEARCH_ROUTE_PATH,
  FOOTER_DPG_CONDITIONS_ROUTE_PATH,
  FOOTER_FAQ_ROUTE_PATH,
  FOOTER_GENERAL_TERMS_AND_CONDITIONS_ROUTE_PATH,
  FOOTER_HOLIDAYS_ROUTE_PATH,
  FOOTER_IMPRINT_ROUTE_PATH,
  FOOTER_PRIVACY_ROUTE_PATH,
  NOT_FOUND_ROUTE_PATH,
} from './items';

// Content
export const CONTENT_ROOT_PATH: string = 'shop';

// Shop Catalog Search
export const CATEGORY_ROOT_PATH: string = 'de';

export const PAGE_ROOT_PATHS: string[] = [
  // Content
  CONTENT_ROOT_PATH,

  // CMS Content V1
  'applications',

  // Shop Catalog Search
  CATEGORY_ROOT_PATH,
];

export const FOOTER_PAGE_ROUTE_PATHS: string[] = [
  FOOTER_FAQ_ROUTE_PATH,
  FOOTER_GENERAL_TERMS_AND_CONDITIONS_ROUTE_PATH,
  FOOTER_DPG_CONDITIONS_ROUTE_PATH,
  FOOTER_PRIVACY_ROUTE_PATH,
  FOOTER_IMPRINT_ROUTE_PATH,
  FOOTER_HOLIDAYS_ROUTE_PATH,
  NOT_FOUND_ROUTE_PATH,
];

export const SCANNER_ROUTE_NAME: string = 'scanner';

/** URL fragments identifying product search result pages */
export const PRODUCT_SEARCH_URL_FRAGMENTS: string[] = [
  CATALOG_SEARCH_ROUTE_PATH,
  // CMS search
  'schnellsuchfunktion',
];
